import { cellStyle } from "../../../../components/Table/Table.styles";

// define your columns
export const getColumns = (role?: any, token?: string) => {
  return [
    {
      title: "Member",
      field: "fullName",
      cellStyle: cellStyle,
      render: (member: any) => {
        return (
          <div style={{ display: "flex", alignItems: "center" }}>
            <img
              src={`${process.env.REACT_APP_API_URL}/members/${member.id}/photo?authorization=${token}`}
              style={{
                marginRight: "9.22px",
                height: "32px",
                width: "40px",
                borderRadius: "7px",
                objectFit: "cover",
              }}
            />
            <span
              style={{
                fontWeight: "600" as any,
                lineHeight: "18px",
                color: "#373F41",
              }}
            >
              {member.fullName}
            </span>
          </div>
        );
      },
    },
    {
      title: "Role",
      field: "",
      searchable: false,
      cellStyle: cellStyle,
      render: () => {
        return <>{role}</>;
      },
    },
    {
      title: "Team",
      field: "team",
      searchable: false,
      cellStyle: cellStyle,
    },
    {
      title: "Office",
      field: "office",
      searchable: false,
      align: "left",
      cellStyle: cellStyle,
    },
    {
      title: "Company",
      field: "companies",
      searchable: false,
      align: "left",
      cellStyle: cellStyle,
      render: (member: any) => {
        return <>{member.companies[0]}</>;
      },
    },
  ];
};
